import { StoryblokComponent } from "gatsby-source-storyblok"
import React from "react"

import ArticleSection from "@components/V2/Layouts/ArticleSection"
import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

const StoryblokArticleSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ArticleSection>) => {
  return (
    <ArticleSection
      title={blok.title}
      publicationInfo={blok.publicationInfo}
      ctaText={blok.ctaText}
      ctaLink={
        blok.ctaLink && linkIsNotNull(blok.ctaLink)
          ? getUrlFromStoryblokLink(blok.ctaLink)
          : undefined
      }
      socialLinks={blok.socialLinks}
      backgroundColor={blok.backgroundColor}
    >
      {blok.articleItems?.map((blok) => (
        <StoryblokComponent key={blok._uid} blok={blok} />
      ))}
    </ArticleSection>
  )
}

export default StoryblokArticleSection
